import React, { useEffect, useState } from "react";

import { useGetBussinessStatistics } from "../../lib/queries/queriesAndMutations";
// import LineChart from "./LineChart";
import Button from "./../ui/Button";

const Statistics = ({ type, id }) => {
  const [timeFrame, setTimeFrame] = useState("week");

  const { data, refetch } = useGetBussinessStatistics({
    business_type: type,
    business_id: id,
    time_frame: timeFrame,
  });

  useEffect(() => {
    refetch();
  }, [timeFrame, refetch]);

  return (
    <div className="flex flex-col  gap-4  shadow-xl p-4    ">
      <div className="flex-1 gap-4  p-8">
        <div className="flex-between mb-2 ">
          <p>آمارکلی</p>

          <div className="flex gap-2">
            <Button
              onClick={() => setTimeFrame("week")}
              className={` ${timeFrame === "week" && "border-b-2 border-blue-500"} bg-white rounded-none p-2`}
            >
              هفت روز گذشته
            </Button>
            <Button
              onClick={() => setTimeFrame("month")}
              className={` ${
                timeFrame === "month" && "border-b-2 border-blue-500"
              } bg-white rounded-none p-2`}
            >
              سی روز گذشته
            </Button>
          </div>
        </div>
        <hr className=""></hr>
      </div>
      {/* <div className=" max-h-[50vh] flex-center">
        <LineChart chartData={data} timeFrame={timeFrame} />
      </div> */}
    </div>
  );
};

export default Statistics;
